<template>
  <div>
    <el-dialog
      width="900px"
      title="下载"
      class="dialogEDA"
      :before-close="close"
      :close-on-click-modal="false"
      :visible.sync="dialogDownloadVisible"
    >
      <div class="table">
        <el-table
          ref="dialogDownloadTable"
          :data="cosTable"
          tooltip-effect="dark"
          v-loading="tableLoading"
          class="base-width_fullscreen"
          @selection-change="handleCheckAllChange"
        >
          <!-- 多选框 -->
          <el-table-column :selectable="selectable" type="selection" width="55"></el-table-column>

          <!-- 文件名 -->
          <el-table-column label="文件名" width="280">
            <template slot-scope="scope">
              <div v-if="scope.row.isDir">
                <i class="el-icon-folder-opened base-margin__right-5"></i>
                <el-button style="padding: 0" type="text">{{ scope.row.name }} </el-button>
              </div>

              <div v-else>
                <i class="el-icon-tickets base-margin__right-5"></i>
                <span>{{ scope.row.name }}</span>
              </div>
            </template>
          </el-table-column>

          <!-- 文件大小 -->
          <el-table-column label="文件大小">
            <template slot-scope="scope">{{ sizeFilter(scope.row.size) }}</template>
          </el-table-column>
          <!-- 日期 -->
          <el-table-column label="日期" width="220">
            <template slot-scope="scope">{{ scope.row.time }}</template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button class="buttonBackground_cls" type="text" @click="deleteFile(scope.row)"> 删除 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页器 -->
      <el-pagination
        align="right"
        @size-change="handleSizeChange"
        @current-change="onCurrentChange"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :current-page="currentPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="cosTotal"
      >
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-if="cosFileList.length !== 0"
          @click="downloadFile"
          :loading="downloadLoading"
          type="primary"
          class="dialogTrueCls"
        >
          下载
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getMimeType, processISO8601Time, processTime } from '@/common/utils/utils';
import { cosDeleteObject, cosGetBucket, cosGetObject } from '@/common/utils/cosApi';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import { Message } from 'element-ui';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'downloadFile',
  props: {
    showDirectory: {
      type: Boolean,
      default: true,
    },
    handleClose: Function, // 关闭弹窗函数
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },

  data() {
    return {
      checkedFilesList: [], // 所选的文件列表
      downloadLoading: false, // 下载文件loading
      processTime,
      currentPage: 1,
      pageSize: 10,
      dialogDownloadVisible: false,
      cosFileList: [],
      tableLoading: false,
      cosTable: [],
      cosTotal: 0,
      imageType: 'windows',
      downloadData: {},
    };
  },

  methods: {
    /**
     * 禁用table列的checkbox
     */
    selectable(row) {
      if (row.size < 1024 * 1024 * 1024) {
        return true;
      }
      return false;
    },

    /**
     * 打开下载文件列表
     * @param applyId 申请ID
     */
    openDownload(data) {
      console.log(data, 'fff');
      this.downloadData = data;
      const currentProject = this.getCurrentProject() || {};
      this.imageType = currentProject.env.imageType;
      this.dialogDownloadVisible = true;
      this.tableLoading = true;
      this.cosFileList = [];
      // 获取文件信息
      cosGetBucket(data)
        .then((res) => {
          res.Contents.forEach((item) => {
            if (item.Key.substr(-1) === '/') return;
            this.cosFileList.push({
              name: item.Key.split(res.Prefix)[1],
              time: processISO8601Time(item.LastModified),
              size: item.Size,
              isDir: false,
            });
          });
          this.cosTotal = this.cosFileList.length;
          this.vuePagination();
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    /**
     * 分页器钩子函数 页数修改时触发
     */
    onCurrentChange(page) {
      this.currentPage = page;
      this.vuePagination();
    },

    // 前端分页
    vuePagination() {
      this.cosTable = this.cosFileList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    },
    /**
     * 每页显示数量钩子函数  每页显示数量修改时触发
     */
    handleSizeChange(pageSize) {
      this.currentPage = 1;
      this.pageSize = pageSize;
      this.vuePagination();
    },
    /**
     * 关闭同步服务器文件弹窗
     */
    closeDirectoryVisible() {
      this.currentPage = 1; // 当前页数
      this.pageIndex = 1; // 分页index
      this.checkedFilesList = [];
      this.vuePagination();
    },
    /**
     * table选择事件
     */
    handleCheckAllChange(val) {
      const nameList = [];
      val.forEach((item) => {
        nameList.push(item.name);
      });
      this.checkedFilesList = nameList;
    },

    /**
     * 弹窗关闭
     */
    close() {
      this.pageIndex = 1; // 分页index
      this.currentPage = 1; // 当前页数
      this.tableLoading = false;
      this.checkedFilesList = [];
      this.dialogDownloadVisible = false;
      this.cosFileList = [];
      this.downloadLoading = false;
    },

    /**
     * 处理文件时间
     */
    dateFilter(date) {
      let str = '';
      str = date.substr(0, date.lastIndexOf('.'));
      str = str.replace('T', '  ');
      return str;
    },

    /**
     * 文件大小过滤
     */
    sizeFilter(value) {
      const text = '';
      const size = value / 1;
      if (size >= 1024 * 1024 * 1024) {
        return `${(size / 1024 / 1024 / 1024).toFixed(2)}G (文件过大，请到使用cosbrower下载)`;
      }
      if (1024 * 1024 < size && size < 1024 * 1024 * 1024) {
        return `${(size / 1024 / 1024).toFixed(2)}M`;
      }
      if (size < 1024 * 1024) {
        return `${(size / 1024).toFixed(2)}KB`;
      }
      return text || '0.00KB';
    },

    /**
     * 文件下载
     */
    downloadFile() {
      this.downloadLoading = true;
      let fileName = '';
      let fileType = '';
      if (this.checkedFilesList.length !== 0) {
        this.$message.success('正在下载并压缩实验文件，请稍后...');
        const fileList = this.checkedFilesList.map(item => cosGetObject(item, this.downloadData));
        if (this.checkedFilesList.length === 1) {
          fileName = this.checkedFilesList[0];
          fileType = getMimeType(fileName);
          Promise.all(fileList).then((res) => {
            // 直接使用原始数据创建Blob，避免通过generateFile中转破坏二进制数据
            const blob = new Blob([res[0].Body], { type: fileType });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(url);
            this.checkedFilesList = [];
            this.downloadLoading = false;
            this.close();
          });
        } else {
          fileName = 'file.zip';
          fileType = 'application/octet-stream';
          const zip = new JSZip();
          Promise.all(fileList).then((res) => {
            for (let i = 0; i < this.checkedFilesList.length; i++) {
              // 直接使用原始数据添加到zip文件，避免通过generateFile中转破坏二进制数据
              zip.file(this.checkedFilesList[i], res[i].Body, { binary: true });
            }
            zip.generateAsync({ type: 'blob' }).then(
              (res) => {
                saveAs(res, fileName);
                this.close();
              },
              () => {
                this.close();
              },
            );
            this.checkedFilesList = [];
            this.downloadLoading = false;
          });
        }
      } else {
        this.downloadLoading = false;
        this.$message('请选择需要下载的文件');
      }
    },

    /**
     * 删除文件
     */
    deleteFile(data) {
      Message.warning('删除文件中，请稍后...');
      cosDeleteObject(data.name, this.downloadData)
        .then(() => {
          Message.success('删除文件成功');
          this.openDownload({});
        })
        .catch((err) => {
          Message.error(`删除文件失败${err}`);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.dialogEDA {
  ::v-deep .el-dialog__header {
    text-align: left !important;
  }
}

// table 背景颜色+padding10px
.table {
  background: #fff;
  //padding: 10px;
  // table内容部分下边距和最小高度
  .el-table {
    margin-bottom: 10px;
    min-height: 264px;
  }
}

.dialogTrueCls {
  background-image: none !important;
}
.buttonBackground_cls {
  background: none !important;
}
</style>
